/**
 * CodaThumb — the last thumb in a house's strip: the wall's ghost at thumb size, dashed, the pen
 * (plan 2026_09_23_pack_stage_coda.md § Decided 2). A real button; the house sizes it with its own
 * thumb class (`className`) so it sits in the strip like the nine before it.
 */
import {Pen} from '@core/wall/ui/Ghost'
import styles from './StagePieces.module.scss'

export interface CodaThumbProps {
    /** The house's thumb class — size, ratio, radius. */
    className?: string
    on: boolean
    label: string
    onSelect: () => void
    role?: string
}

export function CodaThumb({className, on, label, onSelect, role}: CodaThumbProps) {
    return (
        <button
            type="button"
            className={[className, styles.codaThumb, on ? styles.codaThumbOn : ''].filter(Boolean).join(' ')}
            onClick={onSelect}
            aria-label={label}
            aria-pressed={on}
            role={role}
        >
            <span className={styles.codaThumbPen} aria-hidden="true"><Pen /></span>
        </button>
    )
}
